var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-current-step"},[_c('div',{staticClass:"c-current-step__current"},[_vm._v("\n    "+_vm._s(_vm.current)+"\n  ")]),_c('div',{staticClass:"c-current-step__max"},[_vm._v(" / "+_vm._s(_vm.max))])])}
var staticRenderFns = []

export { render, staticRenderFns }